import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { parseRequired } from '../../../Utils/form.util';
import { loadDOMComponent } from '../../../helpers';
import { store } from '../../../store/store';
import { AppContextProvider } from '../../../Services/AppContext';
import VideoWithAudioInput from './VideoWithAudioInput';

loadDOMComponent({
	selector: 'react-video-with-audio-field',
	callback: ({ container, context, props }: any) => {
		const src = container.getAttribute('data-src');
		const name = container.getAttribute('name');
		const netteRules = container.getAttribute('data-nette-rules');
		const required = parseRequired(container.getAttribute('required'));
		const timeLimitInSeconds = parseInt(
			container.getAttribute('timeLimitInSeconds'),
		);

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<VideoWithAudioInput
						video={src}
						name={name}
						netteRules={netteRules}
						isRequired={required}
						timeLimitInSeconds={timeLimitInSeconds}
					/>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
